import { API_ENDPOINTS } from "@/configs";
import apiRequest from "@/lib/axios";
import { AccountStatus, CompleteProfileForm, GeoStatus } from "@/types";

import { VerifyChannel, VerifyState, VerifyStatus } from "./type";

export type { VerifyChannel, VerifyState, VerifyStatus };

export const getVerifyStatus = async (): Promise<VerifyStatus> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.AUTH.VERIFY_STATUS,
    errorMessage: "Failed to load verification status",
  });
};

export const sendVerifyCode = async (
  channel: VerifyChannel,
  phone?: string,
): Promise<{ sent: boolean }> => {
  return apiRequest({
    method: "POST",
    url: API_ENDPOINTS.AUTH.VERIFY_STATUS_SEND,
    data: { channel, phone },
    errorMessage: "Failed to send verification code",
  });
};

export const confirmVerifyCode = async (
  channel: VerifyChannel,
  code: string,
  phone?: string,
): Promise<VerifyStatus> => {
  return apiRequest({
    method: "POST",
    url: API_ENDPOINTS.AUTH.VERIFY_STATUS_VERIFY,
    data: { channel, code, phone },
    errorMessage: "Failed to verify code",
  });
};

export const updateAnonymous = async (isAnonymous: VerifyState): Promise<VerifyStatus> => {
  return apiRequest({
    method: "PUT",
    url: API_ENDPOINTS.AUTH.VERIFY_STATUS,
    data: { isAnonymous },
    errorMessage: "Failed to update anonymous setting",
  });
};

// Confirms the link from the verification email; needs no session.
export const verifyEmailLink = async (token: string): Promise<{ verified: boolean }> => {
  return apiRequest({
    method: "POST",
    url: API_ENDPOINTS.AUTH.VERIFY_EMAIL,
    data: { token },
    errorMessage: "Failed to verify email",
  });
};

export const resendVerificationEmail = async (): Promise<{ sent: boolean }> => {
  return apiRequest({
    method: "POST",
    url: API_ENDPOINTS.AUTH.SEND_VERIFICATION_EMAIL,
    errorMessage: "Failed to send verification email",
  });
};

export const getAccountStatus = async (): Promise<AccountStatus> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.AUTH.ACCOUNT_STATUS,
    errorMessage: "Failed to load account status",
  });
};

export const completeProfile = async (data: CompleteProfileForm): Promise<AccountStatus> => {
  return apiRequest({
    method: "POST",
    url: API_ENDPOINTS.AUTH.COMPLETE_PROFILE,
    data,
    errorMessage: "Failed to save profile",
  });
};

export const importGoogleBirthday = async (accessToken: string): Promise<AccountStatus> => {
  return apiRequest({
    method: "POST",
    url: API_ENDPOINTS.AUTH.GOOGLE_BIRTHDAY,
    data: { accessToken },
    errorMessage: "Failed to read your Google birthday",
  });
};

// Country of the caller's IP, for prefilling sign-up; needs no session.
export const getGeoStatus = async (): Promise<GeoStatus> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.AUTH.GEO,
    errorMessage: "Failed to load location",
  });
};
